<template>
 <v-app>
     <v-app-bar
      color="primary"
      app
      clipped-left
      dark
      class="no-print"
    >
      <v-app-bar-nav-icon class="no-print"  v-if="account.status.loggedIn" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
              @click="$router.push('/')"
              class="display-1"
              style="cursor:pointer">
        <v-icon  large>mdi-fuel</v-icon> ATK Web
      </v-toolbar-title>
      <v-spacer></v-spacer>
        <v-btn to="/login"
        v-if="account.status.loggedIn" x-large
        icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      v-if="account.status.loggedIn"
      height="100%"
      class="no-print"
    >
      <v-list nav dense  two-line>
        <router-link to="/profile">
      <v-list-item >
        <v-list-item-avatar color="primary">
              <v-icon dark>mdi-account-circle</v-icon>
            </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title wrap pb-1">
            {{user.fullName}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{user.email}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      </router-link>

      <v-divider></v-divider>
        <template v-for="item in items">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              ></a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="mdi-chevron-down"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link :to="child.link"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link :to="item.link"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-slot:append>
            <div class="pt-1 px-2">
              <v-row>
                <v-col class="pb-0">
                  <v-btn link to="/uploadReport"  block color="primary">
                    <v-icon class="pr-3">mdi-cloud-upload</v-icon> Загрузить отчет
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-btn color="primary" @click="selectTheme"
                     block>
                    <v-icon class="pr-3" >mdi-theme-light-dark</v-icon> Сменить тему
                  </v-btn>
                </v-col>
                </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-subheader>Версия сайта: {{version}}</v-subheader>
                </v-col>
                <v-col class="py-0">
                  <v-subheader><router-link to="policy">Политика конфиденциальности</router-link></v-subheader>
                </v-col>
              </v-row>
            </div>
      </template>
    </v-navigation-drawer>

    <!-- Sizes your content based upon application components -->
    <v-main app style="fill-height" class="print">

      <!-- Provides the application the proper gutter -->
      <v-container fluid style="height:100%;" class="ma-0 pa-1 print">
        <v-alert
          v-if="alert.message"
          :type="alert.type"
          dark
          class="no-print"
        >
        {{alert.message}}
        </v-alert>
        <v-fab-transition class="no-print">
         <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            large
            dark
            fixed
            bottom
            right
            color="primary"
            @click="toTop"
          >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
          </v-fab-transition>
        <!-- If using vue-router -->
        <router-view class=""></router-view>
      </v-container>
    </v-main>
    <v-footer
    class="font-weight-medium"
    >
    <v-row style="height: 100%;">
      <v-col
      cols="12"
      md="12"
      lg="12"
      xl="12"
      sm="12"
        class="text-center"
      >
        {{ new Date().getFullYear() }} — <strong>ООО Аргус</strong>
      </v-col>
    </v-row>
    </v-footer>
  </v-app>

<!--     <div class="jumbotron">
        <div class="container">
            <div class="row">
              <div v-if="account.status.loggedIn">
              </div>
                <div class="col-sm-6 offset-sm-3">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
 -->

 </template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      fab: false,
      version: process.env.VUE_APP_VERSION,
      drawer: true,
      items: [
        { icon: 'mdi-view-dashboard-variant', text: 'Рабочий стол', link: '/' },
        {
          icon: 'mdi-sitemap',
          'icon-alt': 'mdi-sitemap',
          text: 'Объекты',
          model: true,
          children: [
            { icon: 'mdi-car-connected', text: 'Транспортные средства', link: '/devices' },
            { icon: 'mdi-web', text: 'Системы мониторинга', link: '/accounts' }
          ]
        },
        {
          icon: 'mdi-file-chart',
          'icon-alt': 'mdi-file-chart',
          text: 'Отчеты',
          model: true,
          children: [
            { icon: 'mdi-credit-card-clock-outline', text: 'Транзакции за период', link: '/transactionReport' },
            { icon: 'mdi-file-chart-outline', text: 'Сводный отчет (АвтоГРАФ)', link: '/agReport' }
          ]
        }
      ],
      mini: true
    }
  },
  name: 'app',
  computed: {
    ...mapState({
      account: state => state.account,
      user: state => state.users.user,
      alert: state => state.alert
    })
  },
  created () {
    this.updateTheme()
    this.getUserInfo(this.account.user.id)
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear',
      getUserInfo: 'users/getUserInfo'
    }),
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    updateTheme () {
      const theme = localStorage.getItem('theme') === 'true'
      if (theme) {
        this.$vuetify.theme.dark = true
        this.$vuetify.theme.light = false
      } else {
        this.$vuetify.theme.dark = false
        this.$vuetify.theme.light = true
      }
    },
    selectTheme () {
      const theme = localStorage.getItem('theme') === 'true'
      if (theme) {
        localStorage.setItem('theme', false)
      } else {
        localStorage.setItem('theme', true)
      }
      this.updateTheme()
    }
  },
  watch: {
    $route (to, from) {
      // clear alert on location change
      this.clearAlert()
    }
  }
}
</script>
<style>
@media print {
    .no-print > * {
        display: none;
    }
    .print {
      display:block;
      padding: 0 !important;
      margin: 0;
      z-index:999;
    }
}
</style>
